import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit'
import { PickupWrapper } from 'Components/City/Page/Pickup/PickupWrapper'
import CityPage from './../../../../Containers/City/Page'
import PickupForm from './../../../../Containers/Form/City/Pickup'
import BrandAmbassadors from 'Containers/City/DataHOCs/BrandAmbassadors'
import { getCityLink } from 'Utils/Link'
import { ACTION_EDIT } from 'constants.js'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'

class Pickup extends PureComponent {
  render = () => {
    return (
      <CityPage
        active={this.props.nav}
        cityId={this.props.cityId}
        history={this.props.history}
        match={this.props.match}
        cityName={this.props.cityName}
        breadcrumbs={[{ label: 'Pickup' }]}
      >
        <Link
          to={getCityLink(this.props.cityId, ACTION_EDIT)}
          className="link-edit-main"
        >
          <StyledIconButton>
            <EditIcon />
          </StyledIconButton>
        </Link>
        <PickupWrapper>
          <BrandAmbassadors
            {...this.props}
            cityDataLoaded={this.props.cityDataLoaded}
            cityId={this.props.cityId}
            clients={this.props.clients}
            campaigns={this.props.campaigns}
          >
            <PickupForm
              history={this.props.history}
              match={this.props.match}
              cityId={this.props.cityId}
              {...this.props}
            />
          </BrandAmbassadors>
        </PickupWrapper>
      </CityPage>
    )
  }
}

export default Pickup
